module.exports = __webpack_public_path__ + "static/media/5734.0fb81067.jpg";